'use strict';

/**
* @ngdoc service
* @name tcApp.LegacyScopeSearchService
* @description
* Contains code to find elements in scope based on their legacy IDs
*
*/
angular.module('tc.legacyScope').factory('LegacyScopeSearchService', function(LegacyScopeTweakService) {
	
	// If the id specified refers to the component's select checkbox, returns the row index
	// Otherwise returns null
	var getSelectItemRowIndex = function($scope, id) {
		if ((angular.isDefined($scope.data.listData))
			&& (angular.isDefined($scope.data.listData.selectItemName))) {
			var re = new RegExp($scope.data.listData.selectItemName + 'z(\\d+)');
			var reArray = id.match(re);
			if (reArray !== null) return (Number(reArray[1]) - 1);
		}
		return null;
	};
	
	// Recursive function to get a nested table item given an arbitrary number of nested levels
	var getNestedTableItem = function(nestedComponentItemName, listRow, itemId, rowIndices,
										nestedDisplayAsTree, treeListRows, isSelectItem) {
		if (nestedDisplayAsTree && isSelectItem) {
			// Get the first item name because there is no select item
			itemId = getFirstItemKey(listRow);
		}
		if (rowIndices.length === 0) {
			return listRow[itemId];
		} else {
			var nestedRowIndex = (Number(rowIndices[0]) - 1);
			var nestedRowIndices = rowIndices.slice(1);
			if (nestedDisplayAsTree) {
				if (angular.isUndefined(listRow[itemId])) return undefined;
				// Nested trees are a flat structure, so resursively loop through the list rows for each nested level
				var currentNestedLevel = (listRow._nestedLevel || 0);
				var currentRowIndex = listRow[itemId]._listRowIndex;
				// where itemId is a nested componentTableItem with no data, the item._listRowIndex is sometimes missing
				if ((angular.isUndefined(currentRowIndex)) && (angular.isDefined(listRow._listRowIndex))) {
					currentRowIndex = listRow._listRowIndex;
				}
				for (var listRowIndex = (currentRowIndex + 1),childCount = -1; listRowIndex < treeListRows.length; listRowIndex++) {
					// Ignore rows for lower nested levels
					if (treeListRows[listRowIndex]._nestedLevel > (currentNestedLevel + 1)) continue;
					// Stop processing if we reach a row for a higher level
					if (treeListRows[listRowIndex]._nestedLevel < (currentNestedLevel + 1)) break;
					childCount++;
					if (nestedRowIndex === childCount) {
						return getNestedTableItem(nestedComponentItemName, treeListRows[listRowIndex], itemId,
													nestedRowIndices, true, treeListRows, isSelectItem);
					}
					
				}
			} else {
				if ((angular.isDefined(listRow[nestedComponentItemName].componentData))
					&& (angular.isDefined(listRow[nestedComponentItemName].componentData.listRows))) {
					var nestedListRow = listRow[nestedComponentItemName].componentData.listRows[nestedRowIndex];
					if (angular.isDefined(nestedListRow)) {
						return getNestedTableItem(nestedComponentItemName, nestedListRow, itemId,
													nestedRowIndices, false, null, isSelectItem);
					}
				}
			}
		}
		return undefined;
	};
	
	// Find the first nested component item on the list row and return an object with the name and tree flag
	// If there are multiple nested items, one with tree flag should take preference
	var getNestedComponentItem = function($scope, currentRowIndex) {
		var nestedItemName = '';
		var nestedDisplayAsTree = false;
		angular.forEach($scope.data.listRows[currentRowIndex], function(item, itemName) {
			if ((item.displayType === 'CX') && (!nestedDisplayAsTree)) {
				nestedItemName = itemName;
				nestedDisplayAsTree = (item.nestedDisplayAsTree || false);
			}
		});
		return {
			name: nestedItemName,
			displayAsTree: nestedDisplayAsTree,
		};
	};
	// For nested tree components, returns the list row index ignoring rows on the nested levels
	var getNestedTreeRowIndex = function($scope, currentRowIndex) {
		// For nested trees, ignore rows on nested levels when finding the top level row index
		for (var listRowIndex = 0,rowCount = -1; listRowIndex < $scope.data.listRows.length; listRowIndex++) {
			if ($scope.data.listRows[listRowIndex]._nestedLevel > 0) continue;
			rowCount++;
			if (rowCount === currentRowIndex) {
				currentRowIndex = listRowIndex;
				break;
			}
		}
		return currentRowIndex;
	};
	
	// Retrieves a data item based on item name from the component data object, for use in legacy functions
	// The item can be from either data.listRows, or data.items
	var getItemFromDataObject = function($scope, id, includeButtons) {
		let idMatch;
		// Test if id is referencing a nested table item ('IDz1_2', 'IDz1_2_3', etc)
		if (idMatch = id.match(/(?<itemId>.+)z(?<extendedRowIndex>(?<leafRowIndex>\d+)(_\d+)+)$/)) { // eslint-disable-line no-cond-assign
			// * NOTE the above assignment of idMatch (not comparison ===)
			const itemId = idMatch.groups?.itemId;
			const extendedRowIndex = idMatch.groups?.extendedRowIndex;
			const leafRowIndex = idMatch.groups?.leafRowIndex;
			if ((typeof itemId === 'undefined') || (typeof extendedRowIndex === 'undefined')
				|| (typeof leafRowIndex === 'undefined')) return null;

			// Re-arrange the indices to make sense...
			const rowIndices = (extendedRowIndex.split('_').slice(1));
			rowIndices.push(leafRowIndex);
			let currentRowIndex = (Number(rowIndices[0]) - 1);
			currentRowIndex = getNestedTreeRowIndex($scope, currentRowIndex);
			if (!$scope.data.listRows?.[currentRowIndex]) return null;

			// Find the first nested component item
			const nestedComponentItem = getNestedComponentItem($scope, currentRowIndex);
			if (nestedComponentItem.name === '') return null;

			const isSelectItem = (getSelectItemRowIndex($scope, id) !== null);
			const nestedTableItem = getNestedTableItem(nestedComponentItem.name,
				$scope.data.listRows[currentRowIndex], itemId, rowIndices.slice(1), nestedComponentItem.displayAsTree,
				$scope.data.listRows, isSelectItem);
			if (typeof nestedTableItem === 'undefined') return null;

			if (isSelectItem) {
				const currentPage = ($scope.data.listData.pageCount - 1);
				return {
					id,
					checked: !!$scope.viewModel.listSettings.selectedRows[currentPage][nestedTableItem._listRowIndex],
					_listRowIndex: nestedTableItem._listRowIndex,
					isSelectItem: true,
				};
			} else if (!nestedComponentItem.displayAsTree) {
				LegacyScopeTweakService.extendItemObject(id, nestedTableItem);
			}
			return nestedTableItem;
		} else if (idMatch = id.match(/(?<itemId>.+)z(?<rowIndex>\d+)(?:\.(?<dynamicColumnIndex>\d+))?$/)) { // eslint-disable-line no-cond-assign
			// Test if id is referencing a table item ('123z4'), or dynamic column table item ('123z4.5')
			// * NOTE the above assignment of idMatch (not comparison ===)
			if (!$scope.data.listRows) return null;
			const itemId = idMatch.groups?.itemId;
			const rowIndex = (idMatch.groups?.rowIndex - 1);
			if ((typeof itemId === 'undefined') || !Number.isInteger(rowIndex) || (rowIndex < 0)) return null;

			// For nested trees, filter out everything except the top level
			const topLevelRows = $scope.data.listRows.filter(listRow => (typeof listRow._nestedLevel === 'undefined'));
			if (typeof topLevelRows[rowIndex] === 'undefined') return null;

			if (getSelectItemRowIndex($scope, id) === null) {
				if (idMatch.groups?.dynamicColumnIndex) {
					// Dynamic column table item
					return (topLevelRows[rowIndex][itemId]?.[idMatch.groups.dynamicColumnIndex - 1] ?? null);
				} else {
					// Normal table item
					return (topLevelRows[rowIndex][itemId] ?? null);
				}
			} else {
				// Select checkbox item
				const firstItemId = getFirstItemKey(topLevelRows[rowIndex]);
				if (angular.isDefined(firstItemId) && angular.isDefined(topLevelRows[rowIndex][firstItemId])) {
					// selectedRows is keyed on the actual row index, including nested levels
					const firstItemRowIndex = topLevelRows[rowIndex][firstItemId]._listRowIndex;
					const currentPage = ($scope.data.listData.pageCount - 1);
					return {
						id,
						checked: !!$scope.viewModel.listSettings.selectedRows[currentPage][firstItemRowIndex],
						_listRowIndex: firstItemRowIndex,
						isSelectItem: true,
					};
				}
			}
		} else if ($scope.data?.items?.[id]) {
			if ((!includeButtons) && ($scope.data.items[id].displayType === 'B')) return null;
			return ($scope.data.items[id] ?? null);
		}
		return null;
	};
	
	// returns the first tableItem name for a row object
	var getFirstItemKey = function(rowObject) {
		var keys = Object.keys(rowObject);
		var key;
		for (var i = 0; i <= keys.length; i++) {
			if (angular.isDefined(keys[i])) {
				key = keys[i];
				if (!LegacyScopeTweakService.isListRowMetaData(key)) {
					return key;
				}
			}
		}
		return undefined;
	};
	
	/// returns the item given an options json object
	/// provides consistent options naming for
	/// options = {
	/// 	'item' : object
	/// 	'itemName' : string
	/// }
	var getItemFromOptions = function($scope, options, includeButtons = true) {
		var item;
		if (angular.isObject(options.item)) {
			item = options.item;
		} else {
			if (angular.isString(options.itemName) && (options.itemName !== '')) {
				item = getItemFromDataObject($scope, options.itemName, includeButtons);
			}
		}
		return item;
	};
	
	return {
		getItemFromDataObject: getItemFromDataObject,
		getItemFromOptions: getItemFromOptions,
		getFirstItemKey: getFirstItemKey
	};
});
